const COMMON_EN = Object.freeze({
    'vertical.title': '',
    'common.title.notification': 'Notification',
    'common.na': 'N/A',
    'common.account': 'Account',
    'common.download': 'Download',
    'common.confirm': 'Confirm',
    'common.cancel': 'Cancel',
    'common.back': 'Back',
    'common.day': 'days',
    'common.yes': 'Yes',
    'common.as': 'As',
    'common.no': 'No',
    'common.outstanding': 'Outstanding',
    'common.remitted': 'Fully Remitted',
    'common.overdue': 'Overdue',
    'common.traded': 'Traded',
    'common.lost': 'Lost',
    'tab.title.marketplace': 'Marketplace',
    'tab.title.balance-asset': 'Balance & Assets',
    'tab.title.profile-setting': 'Profile & Settings',
    'common.select-all': 'Select all',
    'common.all': 'All',
    'common.days': 'days',
    'common.free-cash-balance-title': 'Free Cash Balance',
    'common.welcome': 'Welcome',
    'common.submit': 'Submit',
    'common.reset': 'Reset',
    'common.validator.form.error': 'Some fields are missing / wrong format',
    'settings.menu.logout': 'Logout',
    'validate.invalid.email': 'Invalid email format',
    'validate.invalid.missing': 'Required Field',
    'validate.invalid.field': 'Invalid field',
    'common.search-text': 'Input search text',
    'common.token-expired-title': 'Session Expired',
    'common.token-expired-description': 'Session expired. Please re-login.',
    'common.placeholder.search': 'Search...',
    'common.exportCSV': 'Export CSV',
    'common.exportCSV.auction': 'Export Auction Summary',
    'common.exportCSV.remittance': 'Export Remittance Record',
    'common.noData': 'No Data',
});

const COMMON_ZH_TW = Object.freeze({
    'vertical.title': '',
    'common.title.notification': '通知',
    'common.na': '不適用',
    'common.account': '帳戶',
    'common.download': '下載',
    'common.confirm': '確認',
    'common.cancel': '取消',
    'common.back': '返回',
    'common.day': '日',
    'common.yes': '是',
    'common.as': '至',
    'common.no': '否',
    'common.outstanding': '未付',
    'common.remitted': '已付',
    'common.overdue': '已過期',
    'common.traded': '已交易',
    'common.lost': '已遺失',
    'tab.title.marketplace': '市場',
    'tab.title.balance-asset': '餘額與資產',
    'tab.title.profile-setting': '帳戶與設定',
    'common.select-all': '選擇全部',
    'common.all': '全部',
    'common.days': '日',
    'common.free-cash-balance-title': '可用現金',
    'common.welcome': '歡迎',
    'common.submit': '提交',
    'common.reset': '重置',
    'common.validator.form.error': '部份資料輸入有誤',
    'settings.menu.logout': '登出',
    'validate.invalid.email': '電郵格式錯誤',
    'validate.invalid.missing': '必填資料',
    'validate.invalid.field': '資料有誤',
    'common.search-text': '輸入搜索文字',
    'common.token-expired-title': '登入逾時',
    'common.token-expired-description': '登入逾時。請再次登入。',
    'common.placeholder.search': '搜尋...',
    'common.exportCSV': '導出CSV',
    'common.exportCSV.auction': '導出資產紀錄',
    'common.exportCSV.remittance': '導出還款紀錄',
    'common.noData': '沒有記錄',
});

export { COMMON_EN, COMMON_ZH_TW };
